import { jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import { ModalBasicClose } from '../Modal.BasicClose/Modal.BasicClose.es.js';
import { ModalContext } from '../Modal.Context/Modal.Context.es.js';

const ModalClose = (props)=>{
    const { disableClose, close } = useContext(ModalContext);
    if (disableClose) {
        // Hide close when disabled
        return null;
    }
    return jsx(ModalBasicClose, {
        ...props,
        onClick: close
    });
};
ModalClose.displayName = 'Modal.Close';

export { ModalClose };
//# sourceMappingURL=Modal.Close.es.js.map
